import {ReactNode} from 'react';

import {Tooltip} from '../../Tooltip/Tooltip';

// Delay keeps tooltips from flickering while the cursor sweeps across the toolbar.
const TOOLBAR_TOOLTIP_OPEN_DELAY_MS = 300;

type ToolbarTooltipProps = {
  label: string;
  isDisabled?: boolean;
  children: ReactNode;
};

// Shared tooltip behavior for toolbar controls. The tooltip's children wrapper stays inside
// the toolbar container, so Quill's `querySelectorAll('button, select')` binding still finds
// the wrapped control; `.ql-formats` lays the wrappers out as a flex row (see quillTheme).
export function ToolbarTooltip(props: ToolbarTooltipProps) {
  return (
    <Tooltip
      label={props.label}
      placement="bottom"
      openDelay={TOOLBAR_TOOLTIP_OPEN_DELAY_MS}
      childrenWrapperDisplay="flex"
      isDisabled={props.isDisabled}
    >
      {props.children}
    </Tooltip>
  );
}
